import { convivaCustomConstants } from './constants/utilConstants';

const vendor = {
  AMAZON: 'Amazon',
  APPLE: 'Apple',
  ASUS: 'vendor.ASUS',
  BLACKBERRY: 'BlackBerry',
  BROWSER: 'Browser',
  CHROME: 'Chrome',
  EDGE: 'Edge',
  FIREFOX: 'Firefox',
  GOOGLE: 'Google',
  HUAWEI: 'Huawei',
  LG: 'vendor.LG',
  MICROSOFT: 'Microsoft',
  MOTOROLA: 'Motorola',
  OPERA: 'Opera',
  SAMSUNG: 'Samsung',
  SHARP: 'Sharp',
  SONY: 'Sony',
  XIAOMI: 'Xiaomi',
  ZEBRA: 'Zebra',
  FACEBOOK: 'Facebook',
  CHROMIUM_OS: 'Chromium OS',
  MAC_OS: 'Mac OS',
  LENOVO: 'Lenovo'
};
export const deviceDetector = () => [
  [
    // Samsung
    /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, vendor.SAMSUNG],
    [convivaCustomConstants.TYPE, convivaCustomConstants.TABLET]
  ],
  [
    /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
    /samsung[- ]([-\w]+)/i,
    /sec-(sgh\w+)/i
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, vendor.SAMSUNG],
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    // Apple
    /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, vendor.APPLE],
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    /\((ipad);[-\w),; ]+apple/i, // iPad
    /applecoremedia\/[\w.]+ \((ipad)/i,
    /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, vendor.APPLE],
    [convivaCustomConstants.TYPE, convivaCustomConstants.TABLET]
  ],
  [/(macintosh);/i],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, vendor.APPLE],
    [convivaCustomConstants.TYPE, convivaCustomConstants.DESKTOP]
  ],
  [
    // Sharp
    /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, vendor.SHARP],
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    // Huawei
    /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, vendor.HUAWEI],
    [convivaCustomConstants.TYPE, convivaCustomConstants.TABLET]
  ],
  [
    /(?:huawei|honor)([-\w ]+)[;)]/i,
    /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, vendor.HUAWEI],
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    // Xiaomi
    /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i, // Xiaomi POCO
    /\b; (\w+) build\/hm\1/i, // Xiaomi Hongmi 'numeric' convivaCustomConstants.MODELs
    /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, // Xiaomi Hongmi
    /\b(redmi[-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, // Xiaomi Redmi
    /oid[^)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i, // Xiaomi Redmi 'numeric' convivaCustomConstants.MODELs
    /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
  ],
  [
    [convivaCustomConstants.MODEL, /_/g, ' '],
    [convivaCustomConstants.VENDOR, vendor.XIAOMI],
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    /oid[^)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i, // Redmi Pad
    /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
  ],
  [
    [convivaCustomConstants.MODEL, /_/g, ' '],
    [convivaCustomConstants.VENDOR, vendor.XIAOMI],
    [convivaCustomConstants.TYPE, convivaCustomConstants.TABLET]
  ],
  [
    // OPPO
    /; (\w+) bui.+ oppo/i,
    /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, 'OPPO'],
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    // Vivo
    /vivo (\w+)(?: bui|\))/i,
    /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, 'Vivo'],
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    // Realme
    /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, 'Realme'],
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    // Motorola
    /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
    /\bmot(?:orola)?[- ](\w*)/i,
    /((?:moto[\w() ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, vendor.MOTOROLA],
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [/\b(mz60\d|xoom[2 ]{0,2}) build\//i],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, vendor.MOTOROLA],
    [convivaCustomConstants.TYPE, convivaCustomConstants.TABLET]
  ],
  [
    // vendor.LG
    /((?=lg)?[vl]k-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, vendor.LG],
    [convivaCustomConstants.TYPE, convivaCustomConstants.TABLET]
  ],
  [
    /(lm(?:-?f100[nv]?|-[\w.]+)(?= bui|\))|nexus [45])/i,
    /\blg[-e;/ ]+((?!browser|netcast|android tv)\w+)/i,
    /\blg-?([\d\w]+) bui/i
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, vendor.LG],
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    // Lenovo
    /(ideatab[-\w ]+)/i,
    /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, vendor.LENOVO],
    [convivaCustomConstants.TYPE, convivaCustomConstants.TABLET]
  ],
  [
    // Nokia
    /(?:maemo|nokia).*(n900|lumia \d+)/i,
    /nokia[-_ ]?([-\w.]*)/i
  ],
  [
    [convivaCustomConstants.MODEL, /_/g, ' '],
    [convivaCustomConstants.VENDOR, 'Nokia'],
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    // Google
    /(pixel c)\b/i // Google Pixel C
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, vendor.GOOGLE],
    [convivaCustomConstants.TYPE, convivaCustomConstants.TABLET]
  ],
  [
    /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, vendor.GOOGLE],
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    // Sony
    /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, vendor.SONY],
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i],
  [
    [convivaCustomConstants.MODEL, 'Xperia Tablet'],
    [convivaCustomConstants.VENDOR, vendor.SONY],
    [convivaCustomConstants.TYPE, convivaCustomConstants.TABLET]
  ],
  [
    // OnePlus
    / (kb2005|in20[12]5|be20[12][59])\b/i,
    /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, 'OnePlus'],
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    // Amazon
    /(alexa)webm/i,
    /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i, // Kindle Fire without Silk / Echo Show
    /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, vendor.AMAZON],
    [convivaCustomConstants.TYPE, convivaCustomConstants.TABLET]
  ],
  [
    /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
  ],
  [
    [convivaCustomConstants.MODEL, /(.+)/g, 'Fire Phone $1'],
    [convivaCustomConstants.VENDOR, vendor.AMAZON],
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    // BlackBerry
    /(playbook);[-\w),; ]+(rim)/i // BlackBerry PlayBook
  ],
  [
    convivaCustomConstants.MODEL,
    convivaCustomConstants.VENDOR,
    [convivaCustomConstants.TYPE, convivaCustomConstants.TABLET]
  ],
  [
    /\b((?:bb[a-f]|st[hv])100-\d)/i,
    /\(bb10; (\w+)/i // BlackBerry 10
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, vendor.BLACKBERRY],
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    // Asus
    /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, vendor.ASUS],
    [convivaCustomConstants.TYPE, convivaCustomConstants.TABLET]
  ],
  [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, vendor.ASUS],
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    // HTC
    /(nexus 9)/i // HTC Nexus 9
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, 'HTC'],
    [convivaCustomConstants.TYPE, convivaCustomConstants.TABLET]
  ],
  [
    /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, // HTC

    // ZTE
    /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
    /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
  ],
  [
    convivaCustomConstants.VENDOR,
    [convivaCustomConstants.MODEL, /_/g, ' '],
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    // Acer
    /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, 'Acer'],
    [convivaCustomConstants.TYPE, convivaCustomConstants.TABLET]
  ],
  [
    // Meizu
    /droid.+; (m[1-5] note) bui/i,
    /\bmz-([-\w]{2,})/i
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, 'Meizu'],
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    // Ulefone
    /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, 'Ulefone'],
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    // MIXED
    /(blackberry|benq|palm(?=-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
    // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
    /(hp) ([\w ]+\w)/i, // HP iPAQ
    /(asus)-?(\w+)/i, // Asus
    /(microsoft); (lumia[\w ]+)/i, // Microsoft Lumia
    /(lenovo)[-_ ]?([-\w]+)/i, // Lenovo
    /(jolla)/i, // Jolla
    /(oppo) ?([\w ]+) bui/i // OPPO
  ],
  [
    convivaCustomConstants.VENDOR,
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    /(kobo)\s(ereader|touch)/i, // Kobo
    /(archos) (gamepad2?)/i, // Archos
    /(hp).+(touchpad(?!.+tablet)|tablet)/i, // HP TouchPad
    /(kindle)\/([\w.]+)/i // Kindle
  ],
  [
    convivaCustomConstants.VENDOR,
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.TYPE, convivaCustomConstants.TABLET]
  ],
  [
    /(surface duo)/i // Surface Duo
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, vendor.MICROSOFT],
    [convivaCustomConstants.TYPE, convivaCustomConstants.TABLET]
  ],
  [
    /droid [\d.]+; (fp\du?)(?: b|\))/i // Fairphone
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, 'Fairphone'],
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    /(shield[\w ]+) b/i // Nvidia Shield Tablets
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, 'Nvidia'],
    [convivaCustomConstants.TYPE, convivaCustomConstants.TABLET]
  ],
  [
    /(sprint) (\w+)/i // Sprint Phones
  ],
  [
    convivaCustomConstants.VENDOR,
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    /(kin\.[onetw]{3})/i // Microsoft Kin
  ],
  [
    [convivaCustomConstants.MODEL, /\./g, ' '],
    [convivaCustomConstants.VENDOR, vendor.MICROSOFT],
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    /droid.+; ([c6]+|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, vendor.ZEBRA],
    [convivaCustomConstants.TYPE, convivaCustomConstants.TABLET]
  ],
  [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.VENDOR, vendor.ZEBRA],
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    ////////////////////
    // MIXED (GENERIC)
    ///////////////////

    /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]
  ],
  [
    /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
  ],
  [
    convivaCustomConstants.MODEL,
    [convivaCustomConstants.TYPE, convivaCustomConstants.TABLET]
  ],
  [
    /\b((tablet|tab)[;/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
  ],
  [[convivaCustomConstants.TYPE, convivaCustomConstants.TABLET]],
  [
    /(phone|mobile(?:[;\\/]| [ \w/\\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
  ],
  [[convivaCustomConstants.TYPE, convivaCustomConstants.MOBILE]],
  [
    /(android[-\w\\. ]{0,9});.+buil/i // Generic Android Device
  ],
  [convivaCustomConstants.MODEL, [convivaCustomConstants.VENDOR, 'Generic']]
];
